import createReactComponent from '../createReactComponent';
export default createReactComponent('tally-five', 'TallyFive', [["path",{"d":"M4 4v16M9.333 4v16m5.334-16v16M20 4v16m1-17L3 21","key":"svg-0"}]]);